import { useEffect, useState } from "react";
import { api } from "./api";

let cache = null;
let ctx = null;

export const loadPrefs = (fresh) => {
  if (cache && !fresh) return Promise.resolve(cache);
  return api.get("/alerts/me").then((r) => { cache = r.data; window.dispatchEvent(new CustomEvent("alert-prefs", { detail: cache })); return cache; });
};

export const useAlertPrefs = () => {
  const [p, setP] = useState(cache);
  useEffect(() => {
    const on = (e) => setP(e.detail);
    window.addEventListener("alert-prefs", on);
    loadPrefs().then(setP).catch(() => {});
    return () => window.removeEventListener("alert-prefs", on);
  }, []);
  return p;
};

const pad = (n) => String(n).padStart(2, "0");
export const inHours = (prefs) => {
  if (!prefs?.hours) return true;
  const d = new Date(Date.now() + 330 * 60000);
  const hm = `${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}`;
  return prefs.hours.days.includes((d.getUTCDay() + 6) % 7) && hm >= prefs.hours.start && hm < prefs.hours.end;
};
export const typeOf = (prefs, kind) => prefs?.kind_type?.[kind];
export const popupOn = (prefs, type) => !prefs || !type || prefs.types[type]?.popup !== false;
export const soundOn = (prefs, type) => !!prefs && !prefs.muted && !!type && !!prefs.types[type]?.sound && inHours(prefs);

const unlock = () => {
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    ctx.resume?.();
  } catch { ctx = null; }
};
if (typeof window !== "undefined") ["pointerdown", "keydown", "touchstart"].forEach((e) => window.addEventListener(e, unlock, { passive: true }));

export const chime = () => {
  if (!ctx || ctx.state !== "running") return;
  const t = ctx.currentTime;
  [[880, 0], [1318.5, 0.14]].forEach(([f, dl]) => {
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.type = "sine";
    o.frequency.value = f;
    g.gain.setValueAtTime(0.0001, t + dl);
    g.gain.exponentialRampToValueAtTime(0.16, t + dl + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, t + dl + 0.6);
    o.connect(g).connect(ctx.destination);
    o.start(t + dl);
    o.stop(t + dl + 0.65);
  });
};

export const setMuted = (muted) => api.put("/me/sound", { muted }).then(() => loadPrefs(true));
